import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableRouteHome = Loadable({
  loader: () => import('./RouteHome.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableRouteHome
